import cx from 'classnames';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import Btn, { BtnLayout } from 'mk2/components/Btn';
import { timeAt } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './AnnouncementBox.mscss';

export const BoxType = {
    Deleted: 'deleted' as 'deleted',
    DeletedMessage: 'deletedMessage' as 'deletedMessage',
    Yellow: 'yellow' as 'yellow',
};
export type BoxType = (typeof BoxType)[keyof typeof BoxType];

interface OwnProps {
    message: string;
    detailMessage?: string | JSX.Element;   // must be string if deletedAt is set
    hasDetailMessage: boolean;
    deletedAt?: string;
    icon?: string;
    deletedBy?: string;
    type: BoxType;
    reasonValue?: string;

    onClose?();
}

const AnnouncementBox: React.StatelessComponent<OwnProps> = ({ icon, message, detailMessage, hasDetailMessage, deletedBy, type, deletedAt, reasonValue, onClose }) => (
    <div className={styles.AnnouncementBox}>
        <div className={styles['AnnouncementBox--type-' + type]}>
            <div className={styles['AnnouncementBox__messageWrapper--type-' + type]}>
                {icon && (
                    <div className={styles['AnnouncementBox__icon--type-' + type]}>
                      <i className={icon} />
                    </div>
                )}
                <div className={styles['AnnouncementBox__message--type-' + type]}>
                    {message}
                    {deletedBy && (
                        <span>&nbsp;(
                            <a
                                className={styles.AnnouncementBox__deletedBy}
                                href={url(blogsProfileUrl, { username: deletedBy })}
                            >
                                {deletedBy}
                            </a>)
                        </span>
                    )}
                </div>
            </div>
            {hasDetailMessage && detailMessage && !deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {detailMessage}
                </div>
            )}
            {hasDetailMessage && detailMessage && deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {interpolate(reasonValue, { reason: detailMessage as string })}
                    <div>{timeAt(deletedAt)}</div>
                </div>
            )}
            {onClose && (
                <Btn
                    className={cx(styles.AnnouncementBox__closeButton, styles['AnnouncementBox__closeButton--type-' + type])}
                    layout={BtnLayout.Icon}
                    icon="fa-times"
                    onClick={onClose}
                />
            )}
        </div>
    </div>
);

export default AnnouncementBox;
